import TranscriptList from "../../components/reusable/TranscriptList";
import { useEffect } from "react";
import { fetchAllTranscripts } from "../../api/transcriptsApi";
import { useDispatch } from "react-redux";
import { setFilteredArchive } from "../../redux/filter/filteredArchiveSlice";
import { compareDates } from "../../services/CompareDates";
import { useState } from "react";

export default function Transcripts() {
  const dispatch = useDispatch();

  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('diploAccessUser');
    setUser(loggedInUser);
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await fetchAllTranscripts();
        response.transcripts = response.transcripts.sort((a, b) => {
          return compareDates(a, b, "descending");
        });
        dispatch(setFilteredArchive(response.transcripts));
      } catch (error) {
        console.log("Failed to fetch transcripts", error);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <div>
      {user && <TranscriptList title={"Transcripts"} />}
    </div>
  );
}
